import { createAction } from 'typesafe-actions';

export const setSelectedTab = createAction('selectedTab/SET_SELECTED_TAB', resolve =>
    (selectedTab: string) => resolve(selectedTab)
);
